// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

import { statusMapper } from '../common'

const convV = v => v ? v.toString().toLowerCase() : ''

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av
    let bv

    switch (col) {
      case 'antenna' :
        // model number is at the antenna level,
        // not antenna-spec
        av = a.modelNumber.toLowerCase()
        bv = b.modelNumber.toLowerCase()
        break

      case 'status' :
        av = statusMapper(a[col])
        bv = statusMapper(b[col])
        break

      default :
        av = convV(a[col])
        bv = convV(b[col])
        break
    }

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

// based on form's values, determine which column to sort by.
export const getSortColByFormValues = formValues => {
  let col
  if (formValues.antennaCode) {
    col = 'antennaCode'
  } else if (formValues.modelNumber) {
    col = 'antenna'
  } else if (formValues.companyName) {
    col = 'company'
  }
  return col
}
